import request from "./request.js";

// 微信授权
export function getWechat_auth(data) {
    return request({
        url: "user/wechat_auth",
        params: data,
        method: "get",
        dataType: "json"
    });
}

// 首页  index/index
export function getIndex(data) {
    return request({
        url: "index/index",
        data: data,
        method: "post",
        dataType: "json"
    });
}
// 产品分类  product/type
export function getType(data) {
    return request({
        url: "product/type",
        data: data,
        method: "get",
        // dataType: "json"
    });
}
// 产品列表  product/lst
export function getLst(data) {
    return request({
        url: "product/lst",
        params: data,
        method: "get",
        dataType: "json"
    });
}
// 手机号登录 user/mobilelogin
export function ToLogin(data) {
    return request({
        url: "user/login",
        params: data,
        method: "get",
        dataType: "json"
    });
}
// 手机号验证码登录  ToMoblieLogin
export function ToMoblieLogin(data) {
    return request({
        url: "user/mobilelogin",
        params: data,
        method: "get",
        dataType: "json"
    });
}

// 发送验证码  index/user/send.html  getAuthCode
export function getAuthCode(data) {
    return request({
        url: "sms/send",
        params: data,
        method: "get",
        dataType: "json"
    });
}
// 注册  ToRegisterMessage
export function ToRegisterMessage(data) {
    return request({
        url: "user/register",
        params: data,
        method: "get",
        dataType: "json"
    });
}

// 产品详情  product/detail
export function productDetails(data) {
    return request({
        url: "product/detail",
        params: data,
        method: "get",
        dataType: "json"
    });
}
// 会员中心  user/index
export function getUserIndex(data) {
    return request({
        url: "user/index",
        params: data,
        method: "get",
        dataType: "json"
    });
}

// 在线采票  index/caipiao
export function getcCaipiao(data) {
    return request({
        url: "index/caipiao",
        params: data,
        method: "get",
        dataType: "json"
    });
}

// 进件海报  product/haibao
export function getHaibao(data) {
    return request({
        url: "product/haibao",
        params: data,
        method: "get",
        dataType: "json"
    });
}

// 系统评估  index/ceping
export function getCeping(data) {
    return request({
        url: "index/ceping",
        data: data,
        method: "POST",
        dataType: "json"
    });
}
// 退出登录   user/logout
export function getLogout(data) {
    return request({
        url: "user/logout",
        params: data,
        method: "get",
        dataType: "json"
    });
}
// 用户进件  user/jinjian
export function getJinjian(data) {
    return request({
        url: "user/jinjian",
        params: data,
        method: "get",
        dataType: "json"
    });
}
// 产品明细  product/desc
export function getDesc(data) {
    return request({
        url: "product/desc",
        params: data,
        method: "get",
        dataType: "json"
    });
}
// 团队管理  team/center
export function getTeamCenter(data) {
    return request({
        url: "team/center",
        params: data,
        method: "get",
        dataType: "json"
    });
}

// 直系列表  team/spread_one
export function getSpread_one(data) {
    return request({
        url: "team/spread_one",
        params: data,
        method: "get",
        dataType: "json"
    });
}
// 非直系列表  team/spread_two
export function getSpread_two(data) {
    return request({
        url: "team/spread_two",
        params: data,
        method: "get",
        dataType: "json"
    });
}

// 进件管理   team/jinjian
export function getTeamJinjian(data) {
    return request({
        url: "team/jinjian",
        params: data,
        method: "get",
        dataType: "json"
    });
}

// 团队列表
export function getTeamLst(data) {
    return request({
        url: "team/lst",
        params: data,
        method: "get",
        dataType: "json"
    });
}

// 资金明细 user/money_log
export function getMoney_log(data) {
    return request({
        url: "user/money_log",
        params: data,
        method: "get",
        dataType: "json"
    });
}

// 用户提现 user/withdraw
export function getWithdraw(data) {
    return request({
        url: "user/withdraw",
        params: data,
        method: "get",
        dataType: "json"
    });
}

// 随机产品  product/rand
export function getProductRand(data) {
    return request({
        url: "product/rand",
        params: data,
        method: "get",
        dataType: "json"
    });
}
// 公告详情  api/index/noticeDetail
export function getNoticeDetail(data) {
    return request({
        url: "index/noticeDetail",
        params: data,
        method: "get",
        dataType: "json"
    });
}
// 新闻详情  api/index/noticeDetail
export function newDetail(data) {
    return request({
        url: "index/newDetail",
        params: data,
        method: "get",
        dataType: "json"
    });
}
// api/user/spread_hb
export function getSpread_hb(data) {
    return request({
        url: "user/spread_hb",
        params: data,
        method: "get",
        dataType: "json"
    });
}

// 评估  api/product/rand
export function getRand(data) {
    return request({
        url: "product/rand",
        params: data,
        method: "get",
        dataType: "json"
    });
}

// 海报素材
export function getPoster(data) {
    return request({
        url: "index/poster",
        params: data,
        method: "get",
    });
}
//生成推广海报
export function getBuildPoster(data) {
    return request({
        url: "index/build_poster",
        params: data,
        method: "get",
    });
}
//通过分类获取海报
export function getPosterByType(data) {
    return request({
        url: "index/poster_more",
        params: data,
        method: "get",
    });
}

//用户实名
export function authentication(data) {
    return request({
        url: "user/authentication",
        params: data,
        method: "get",
        dataType: "json"
    });
}

//获取用户银行卡
export function getBankInfo(data) {
    return request({
        url: "user/getBankInfo",
        params: data,
        method: "get",
        dataType: "json"
    });
}
//更新银行卡信息
export function updateBankInfo(data) {
    return request({
        url: "user/updateBankInfo",
        params: data,
        method: "get",
        dataType: "json"
    });
}
//筛选数据
export function filter(data) {
    return request({
        url: "product/filter",
        params: data,
        method: "get",
        dataType: "json"
    });
}
//筛选数据
export function filterOptions(data) {
    return request({
        url: "product/filter_options",
        params: data,
        method: "get",
        dataType: "json"
    });
}
//录单数据
export function luruList(data) {
    return request({
        url: "product/luruList",
        params: data,
        method: "get",
        dataType: "json"
    });
}
//录单提交
export function luru(data) {
    return request({
        url: "user/luru",
        params: data,
        method: "get",
        dataType: "json"
    });
}
//信息查询
export function sCompany(data) {
    return request({
        url: "index/searchCompany",
        params: data,
        method: "get",
        dataType: "json"
    });
}
//首页开屏广告
export function index_ad(data) {
    return request({
        url: "index/ad",
        params: data,
        method: "get",
        dataType: "json"
    });
}

//客服
export function my_kefu() {
    return request({
        url: "user/my_kefu",
        method: "get",
        dataType: "json"
    });
}



// WEBPACK FOOTER //
// ./src/network/get.js